var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (JSON.stringify(_vm.$route.query) === '{}')?_c('index'):_c('router-view')}
var staticRenderFns = []

export { render, staticRenderFns }